import { render, staticRenderFns } from "./TabelaFrequencia.vue?vue&type=template&id=904bb796&"
import script from "./TabelaFrequencia.vue?vue&type=script&lang=js&"
export * from "./TabelaFrequencia.vue?vue&type=script&lang=js&"
import style0 from "./TabelaFrequencia.vue?vue&type=style&index=0&id=904bb796&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports